// import React, { useEffect, useRef } from 'react';
// import * as d3 from 'd3';

// export default function BarChart({
//     data,
//     width = '100%', // Set default width to 100%
//     height = 400,   // Fixed height to maintain aspect ratio
//     marginTop = 40,
//     marginRight = 20,
//     marginBottom = 50,
//     marginLeft = 60
// }) {
//     const svgRef = useRef();

//     useEffect(() => {
//         const svg = d3.select(svgRef.current);
//         svg.selectAll("*").remove(); // Clear previous content

//         const now = new Date();
//         const months = Array.from({ length: data.length }, (_, i) => {
//             const date = new Date(now);
//             date.setMonth(date.getMonth() - i);
//             return date;
//         }).reverse();

//         const x0 = d3.scaleBand()
//             .domain(months)
//             .range([marginLeft, svg.node().clientWidth - marginRight])
//             .padding(0.1);

//         const x1 = d3.scaleBand()
//             .domain(['paid', 'donation', 'free'])
//             .range([0, x0.bandwidth()])
//             .padding(0.05);

//         const conversionFactor = 10;
//         const y = d3.scaleLinear()
//             .domain([0, d3.max(data, d => Math.max(d.paid, d.donation, d.free)) / conversionFactor])
//             .nice()
//             .range([height - marginBottom, marginTop]);

//         const xAxis = d3.axisBottom(x0).tickFormat(d3.timeFormat("%b %Y"));
//         const yAxis = d3.axisLeft(y).ticks(height / 100);

//         const color = d3.scaleOrdinal()
//             .domain(['paid', 'donation', 'free'])
//             .range(['#5383ec', '#D85140', '#F1BF42']);

//         svg.append("g")
//             .attr("transform", `translate(0,${height - marginBottom})`)
//             .call(xAxis);

//         svg.append("g")
//             .attr("transform", `translate(${marginLeft},0)`)
//             .call(yAxis);

//         const monthGroups = svg.append("g")
//             .selectAll("g")
//             .data(data)
//             .enter().append("g")
//             .attr("transform", (d, i) => `translate(${x0(months[i])},0)`);

//         monthGroups.selectAll("rect")
//             .data(d => ['paid', 'donation', 'free'].map(key => ({ key, value: d[key] / conversionFactor })))
//             .enter().append("rect")
//             .attr("x", d => x1(d.key))
//             .attr("y", d => y(d.value))
//             .attr("width", x1.bandwidth())
//             .attr("height", d => y(0) - y(d.value))
//             .attr("fill", d => color(d.key));

//         const legend = svg.append("g")
//             .attr("transform", `translate(${marginLeft},${marginTop - 30})`);

//         const legendData = [
//             { key: 'paid', label: 'Total no of paid events' },
//             { key: 'donation', label: 'Total no of donation events' },
//             { key: 'free', label: 'Total no of free events' }
//         ];

//         const legendRowWidth = 150;

//         legendData.forEach((d, i) => {
//             const legendRow = legend.append("g")
//                 .attr("transform", `translate(${i * legendRowWidth},0)`);

//             legendRow.append("rect")
//                 .attr("width", 10)
//                 .attr("height", 10)
//                 .attr("fill", color(d.key));

//             legendRow.append("text")
//                 .attr("x", 15)
//                 .attr("y", 10)
//                 .attr("fill", "black")
//                 .style("font-size", "10px")
//                 .text(d.label);
//         });

//     }, [data, height, marginBottom, marginLeft, marginRight, marginTop]);

//     return (
//         <svg
//             ref={svgRef}
//             width={width}
//             height={height}
//             viewBox={`0 0 ${width} ${height}`} // Add viewBox for scaling
//             style={{ maxWidth: '100%', height: 'auto' }} // Ensure responsive sizing
//         ></svg>
//     );
// }


import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';

export default function BarChart({
    data,
    width = '100%', // Set default width to 100%
    height = 400,   // Fixed height to maintain aspect ratio
    marginTop = 40,
    marginRight = 20,
    marginBottom = 50,
    marginLeft = 60
}) {
    const svgRef = useRef();

    useEffect(() => {
        const svg = d3.select(svgRef.current);
        svg.selectAll("*").remove(); // Clear previous content

        const now = new Date();
        const months = Array.from({ length: data.length }, (_, i) => {
            const date = new Date(now);
            date.setMonth(date.getMonth() - i);
            return date;
        }).reverse();

        const x0 = d3.scaleBand()
            .domain(months)
            .range([marginLeft, svg.node().clientWidth - marginRight])
            .padding(0.1);

        const x1 = d3.scaleBand()
            .domain(['paid', 'free']) // Removed "donation"
            .range([0, x0.bandwidth()])
            .padding(0.05);

        const y = d3.scaleLinear()
            .domain([0, d3.max(data, d => Math.max(d.paid, d.free))])
            .nice()
            .range([height - marginBottom, marginTop]);

        const xAxis = d3.axisBottom(x0).tickFormat(d3.timeFormat("%b %Y"));
        const yAxis = d3.axisLeft(y)
            .ticks(height / 100)
            .tickFormat(d3.format("~s")); // Format ticks as whole numbers

        const color = d3.scaleOrdinal()
            .domain(['paid', 'free']) // Removed "donation"
            .range(['#5383ec', '#F1BF42']);

        svg.append("g")
            .attr("transform", `translate(0,${height - marginBottom})`)
            .call(xAxis);

        svg.append("g")
            .attr("transform", `translate(${marginLeft},0)`)
            .call(yAxis);

        const monthGroups = svg.append("g")
            .selectAll("g")
            .data(data)
            .enter().append("g")
            .attr("transform", (d, i) => `translate(${x0(months[i])},0)`);

        monthGroups.selectAll("rect")
            .data(d => ['paid', 'free'].map(key => ({ key, value: d[key] })))
            .enter().append("rect")
            .attr("x", d => x1(d.key))
            .attr("y", d => y(d.value))
            .attr("width", x1.bandwidth())
            .attr("height", d => y(0) - y(d.value))
            .attr("fill", d => color(d.key));

        const legend = svg.append("g")
            .attr("transform", `translate(${marginLeft},${marginTop - 30})`);

        const legendData = [
            { key: 'paid', label: 'Total no of paid events' },
            { key: 'free', label: 'Total no of free events' }
        ];

        const legendRowWidth = 150;

        legendData.forEach((d, i) => {
            const legendRow = legend.append("g")
                .attr("transform", `translate(${i * legendRowWidth},0)`);

            legendRow.append("rect")
                .attr("width", 10)
                .attr("height", 10)
                .attr("fill", color(d.key));

            legendRow.append("text")
                .attr("x", 15)
                .attr("y", 10)
                .attr("fill", "black")
                .style("font-size", "10px")
                .text(d.label);
        });

    }, [data, height, marginBottom, marginLeft, marginRight, marginTop]);

    return (
        <svg
            ref={svgRef}
            width={width}
            height={height}
            viewBox={`0 0 ${width} ${height}`} // Add viewBox for scaling
            style={{ maxWidth: '100%', height: 'auto' }} // Ensure responsive sizing
        ></svg>
    );
}
